import moedaMascara from "../moedaMascara";

function formatarValorPorIndicador(sigla: string, valor: string | number) {

  const siglaFormatada = sigla.toLowerCase();

  const indicadoresMonetarios = ["fat", "lo", "ll", "cmo", "pec", "pef"];
  const indicadoresDias = ["pmr", "pmp", "co", "cf", "gc"];
  const indicadoresPercentual = ["ii", "ia", "ir"];

  if (indicadoresMonetarios.includes(siglaFormatada)) return moedaMascara(valor)
  if (indicadoresDias.includes(siglaFormatada)) return `${valor} dias`
  if (indicadoresPercentual.includes(siglaFormatada)) return `${valor != null ? valor + "%" : ""}`

  return valor;
}

export default function formatarValorTooltip(sigla: string, value: string | number | (string | number)[]) {
  if (Array.isArray(value)) {
    return value.map(v => formatarValorPorIndicador(sigla, v)).join(" / ");
  }
  return formatarValorPorIndicador(sigla, value);
}